












































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";

import CouponCard from "@/components/coupons/CouponCard.vue";
import CouponLongCard from "@/components/coupons/CouponLongCard.vue";
import MerchantCard from "@/components/merchants/MerchantCard.vue";
import OfferCard from "@/components/offer/OfferCard.vue";

import { ICoupon, ICouponLong } from "@/store/interfaces/coupon.ts";
import { IMerchant } from "@/store/interfaces/merchant.ts";
import { IOffer } from "@/store/interfaces/offer.ts";

@Component({
  components: {
    CouponCard,
    CouponLongCard,
    MerchantCard,
    OfferCard
  }
})
export default class Styleguide extends Vue {
  couponCardObject: ICoupon = {
    type: "Type",
    description:
      "Coupon description maximum Lorem ipsum dolor sit amet, consectetur Coupons description",
    img: "/img/img/zalando-logo.png",
    url: "/",
    title: "title",
    date_end: "12.12.2019",
    coupon_code: "code",
    discount: "12",
    merchant_name: "merchant name"
  };
  couponLongCardObject: ICouponLong = Object.assign({}, this.couponCardObject, {
    discount: 15,
    date: "12.12.2000",
    code: "85UO925X9",
    description:
      "Coupons description maximum Lorem ipsum dolor sit amet, consectetur Coupons description maximum, consectetur Coupons description"
  });

  merchantCardObject: IMerchant = {
    id: "1",
    logo: "",
    name: "Name of shop",
    monetizedLink: "#"
  };

  offerCardObject: IOffer = {
    img: "",
    name: "Name of product, name of product, name of",
    store_url: "url.com",
    description: "description of product, description of",
    price: "1200",
    old_price: "1400",
    currency: "$",
    merchant: "merchant.de",
    date: "12.12.2000",
    new: true,
    recommended: true,
    demand: false,
    trending: true
  };
}
